import React from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";
import { getErrorMessage } from "../utils/errorMessages";

const Navbar = () => {
  const { user, logOut, deleteAccount } = UserAuth();
  const { lang } = useLanguage();
  const T = translations[lang].navbar;

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAccount = async () => {
    if (!window.confirm(T.deleteAccountConfirm)) {
      return;
    }
    try {
      await deleteAccount();
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <a href="https://aidify.ca/" target="_blank" rel="noopener noreferrer">
          <img
            src="/AidifyLogo.png"
            alt="Aidify Logo"
            className="navbar-logo"
          />
        </a>
      </div>
      <div className="navbar-end">
        {user?.displayName ? (
          <div className="navbar-user">
            <span className="navbar-welcome">
              {T.welcome(user.displayName)}
            </span>
            <div className="navbar-actions">
              <Link to="/shared-reports" className="navbar-btn navbar-btn--reports">
                {T.myReports}
              </Link>
              <button
                type="button"
                className="navbar-btn navbar-btn--logout"
                onClick={handleSignOut}
              >
                {T.logOut}
              </button>
              <button
                type="button"
                className="navbar-btn navbar-btn--delete"
                onClick={handleDeleteAccount}
              >
                {T.deleteAccount}
              </button>
            </div>
          </div>
        ) : (
          <Link to="/signin"></Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
